module.exports = __webpack_public_path__ + "static/media/moniter.0c8c84d4.png";